import messages from '../../../../locale/messages';

const validate = values => {

  const errors = {}

  if (!values.peaceTitleHeading) {
    errors.peaceTitleHeading = messages.required;
  } else if (values.peaceTitleHeading.trim() == "") {
    errors.peaceTitleHeading = messages.required;
  } else if (values.peaceTitleHeading && values.peaceTitleHeading.length > 200) {
    errors.peaceTitleHeading = messages.exceedLimit;
  }

  if (!values.sharingTitle) {
    errors.sharingTitle = messages.required;
  } else if (values.sharingTitle.trim() == "") {
    errors.sharingTitle = messages.required;
  } else if (values.sharingTitle && values.sharingTitle.length > 200) {
    errors.sharingTitle = messages.exceedLimit;
  }

  if (!values.sharingContent) {
    errors.sharingContent = messages.required;
  } else if (values.sharingContent.trim() == "") {
    errors.sharingContent = messages.required;
  } else if (values.sharingContent && values.sharingContent.length > 400) {
    errors.sharingContent = messages.exceedLimit;
  }

  return errors
}

export default validate;